<template>
    <v-container>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Lower Back Screening (Anatomy)
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Most Affected Parts : <span v-for="anatomy in forms.anatomy" :key="anatomy['id']">{{ anatomy }}</span>
        </div>
        <br>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Lower Back Screening (Remarks)
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Muscle Imbalance : 
            <table>
                <tr>
                    <td>LOWER</td>
                    <td>MIDDLE</td>
                    <td>UPPER</td>
                </tr>
                <tr>
                    <td>{{ forms.imbalance.lower }}</td>
                    <td>{{ forms.imbalance.middle }}</td>
                    <td>{{ forms.imbalance.upper }}</td>
                </tr>
            </table>
            Scoliosis : {{ forms.scoliosis ? 'Yes' : 'No' }} <br>
            Multifidus : {{ forms.multifidus ? 'Yes' : 'No' }} <br>
            Remarks  : {{forms.remark}} <br>
        </div> 
        <br>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Lower Back Screening (Foot Profile)
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Feet  : {{forms.feet}} <br>
            Shoes  : {{forms.shoe}} <br>
            Alignment  : {{forms.alignment}} <br>
        </div>
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Lower Back Screening (EMG Screening)
            <br>
            LEFT
            <table>
                <tr>
                    <td>Standing</td>
                    <td>Bending</td>
                    <td>Extending</td>
                    <td>Sitting</td>
                </tr>
                <tr>
                    <td v-for="left in forms.left_muscle" :key="left['id']">
                        {{ left }}
                    </td>
                </tr>
            </table>
            RIGHT
            <table>
                <tr>
                    <td>Standing</td>
                    <td>Bending</td>
                    <td>Extending</td>
                    <td>Sitting</td>
                </tr>
                <tr>
                    <td v-for="right in forms.right_muscle" :key="right['id']">
                        {{ right }}
                    </td>
                </tr>
            </table>
        </div><br>
          <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
                 Strength Test
            <table>
            <thead>
                <tr>
                    <th id="left">Upper Body</th>
                    <th>Left (kg)</th>
                    <th id="right">Right (kg)</th>
                       <th >Remarks</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(emg, index) in emgReading" :key="emg['id']">
                    <td>{{ emg.type }}</td>
                    <td><input type="number" v-model="forms.strength_upper_left[index]" placeholder="Insert Num"></td>
                    <td><input type="number" v-model="forms.strength_upper_right[index]" placeholder="Insert Num"></td>
                    <td><textarea v-model="forms.strength_upper_remarks[index]" />  </td>
                </tr>  
                  
            </tbody>            
        </table>
         <table>
            <thead>
                <tr>
                    <th id="left">Lower Body</th>
                    <th>Left (kg)</th>
                    <th id="right">Right (kg)</th>
                     <th >Remarks</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(emg, index) in emgReading2" :key="emg['id']">
                    <td>{{ emg.type }}</td>
                    <td><input type="number" v-model="forms.strength_lower_left[index]" placeholder="Insert Num"></td>
                    <td><input type="number" v-model="forms.strength_lower_right[index]" placeholder="Insert Num"></td>
                         <td><textarea v-model="forms.strength_lower_remarks[index]" /></td>
                </tr>  
                  
            </tbody>            
        </table>
        </div>
    </v-container>
</template>
<script>
import db from '@/components/firebase.init';
import Slider from '@/components/Slider';
export default {
    props:['forms'],
    data(){
        return{
              emgReading:[
                {
                    type: 'Internal Rotation'
                },
                {
                    type: 'External Rotation'
                },
                {
                    type: 'Shoulder Abduction'
                },
                {
                    type: 'Shoulder Blade Abduction'
                },
            ],
              emgReading2:[
                {
                    type: 'Hip Extension'
                },
                {
                    type: 'Hip Flexion'
                },
                {
                    type: 'Knee Flexion'
                },
                {
                    type: 'Knee Extension'
                },
            ]

        }
    },
    methods:{
        
    },
    components:{
        'slider' : Slider
    }
}
</script>
<style scoped>
div table tr td{
    padding: 0 10px;
}
table, tr td{
    border: 1px solid white;
}
</style>